import React, { useEffect, useState } from 'react';
import { Container, Card, CardBody } from 'reactstrap';
import { PageHeader } from '../../shared/components';
import powerBIService from '../../services/powerBIService';
import { PowerBIReportDto } from '../../services/types/PowerBI';

const ReportESInsight: React.FC = () => {
  // console.log('PowerBIReports component rendering...');
  const [report, setReport] = useState<PowerBIReportDto | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // console.log('call useEffect...');
    const fetchReport = async () => {
      try {
        // console.log('Fetching E&S Insights report...');
        const data = await powerBIService.getReport();
        setReport(data);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error fetching E&S Insights report:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchReport();
  }, []);

  if (loading) {
    return (
      <Container>
        <PageHeader title="E&S Insights" backUrl="/" />
        <div>Loading...</div>
      </Container>
    );
  }

  if (!report) {
    return (
      <Container>
        <PageHeader title="E&S Insights" backUrl="/" />
        <Card>
          <CardBody>
            <p>E&S Insights report not available</p>
          </CardBody>
        </Card>
      </Container>
    );
  }

  return (
    <Container fluid className="powerbi-reports">
      <PageHeader title="E&S Insights" backUrl="/" />
      <Card>
        <CardBody>
          <iframe title={report.reportName} src={report.reportUrl} className="powerbi-iframe" />
        </CardBody>
      </Card>
    </Container>
  );
};

export default ReportESInsight;
